import { gql } from '@apollo/client';

export const GET_COMPANIES = gql`
  query loadCompanies($input: CompanyInput, $pagingInput: PagingInput) {
    loadCompanies(input: $input, paging: $pagingInput) {
      id
      name
    }
  }
`;
